<template>
  <div class="leave-modal">
    <el-dialog
      class="leave-modal-dialog_leave"
      title="请假"
      :visible="isShow"
      width="560px"
    >
      <el-form
        :model="leave"
        :rules="rules"
        ref="leaveForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="content">
          <el-input
            placeholder="请输入请假原因"
            type="textarea"
            clearable
            :class="{ 'leave-modal-dialog_content': period.is_approve == 2 }"
            v-model="leave.content"
            style="height: 160px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="leave-modal-dialog_tip" v-if="period.is_approve == 1">
        请假需要班主任审核
      </div>
      <template v-slot:footer>
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "LeaveModal",
  props: {
    period: {
      type: Object,
      default: () => {},
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    onLeaveSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isShow: false,
      leave: {
        content: "",
      }, //请假信息
      rules: {
        content: [
          { required: true, message: "请填写请假原因", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    showModal(value) {
      this.isShow = value;
      if (value) {
        this.leave.content = "";
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit("update:showModal", false);
    },
    onSubmit() {
      this.$refs.leaveForm.validate(async valid => {
        if (valid) {
          await this.onLeaveSubmit(this.leave);
          this.onCancel();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.leave-modal {
  /deep/ {
    .el-button {
      padding: 10px 19px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__header,
    .el-dialog__body,
    .el-dialog__footer {
      padding: 0;
    }
    .el-dialog {
      padding: 16px 24px 24px 24px;
    }
    .el-textarea__inner {
      height: 160px;
    }
    .el-textarea {
      margin: 16px 0 8px 0;
    }
  }
  .leave-modal-dialog_content {
    margin-bottom: 24px;
  }
  .leave-modal-dialog_tip {
    margin-bottom: 16px;
  }
}
</style>
